import { env } from "@/src/config/env";

export const API_CONFIG = {
  baseUrl: env.NEXT_PUBLIC_API_BASE_URL,
  timeoutMs: 30000,
} as const;
